import { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { motion, AnimatePresence } from "motion/react";
import AccordionIcon from '@/assets/svg/accordion-icon.svg';
import ImageLink from "../../ImageLink/ImageLink";
import LinkList from "../../LinkList/LinkList";
import { TopLevelNavigation } from "@header";

import styles from "./MenuAccordion.module.scss";
const cx = classNames.bind(styles);

type MenuAccordionProps =
  TopLevelNavigation[number] & {
    isOpen?: boolean;
    index: number;
    onToggle: (id: string) => void;
  };

const ComponentMap: { [key: string]: React.FC } = {
  'image-link': ImageLink,
  'link-list': LinkList,
};

export default function MenuAccordion(props: MenuAccordionProps) {
  const { label, linkGroups, isOpen, onToggle, index } = props;
  const [internalOpen, setInternalOpen] = useState(isOpen);
  const id = `menu-accordion-item-${index}`;
  const onClick = () => {
    onToggle?.(id);
  };
  useEffect(() => { setInternalOpen(isOpen); }, [isOpen]);
  return (
    <div className={cx("menu-accordion")}>
      <button
        className={cx("accordion-button", { open: internalOpen })}
        aria-expanded={internalOpen}
        aria-controls={id}
        id={`${id}-header`}
        type="button"
        onClick={onClick}
        data-gtm-section="nav"
      >
        <p className="title-uc-s">{label}</p>
        <div className={cx("icon-container")}>
          <AccordionIcon className={cx("icon")} />
          <AccordionIcon
            className={cx("icon", "vertical", { open: internalOpen })}
          />
        </div>
      </button>
      <AnimatePresence>
        {internalOpen && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className={cx("accordion-content")}
          >
            {linkGroups.map((group, index) => {
              const Component = ComponentMap[group.groupType?.[0] || ''];
              return Component ? <Component key={index} {...group} /> : null;
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
